import { useState, useCallback } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

import { useDispatch } from 'react-redux'
import { setStartRoomTour } from "../../new-user-experience/actions/onboarding-actions";
import { waitForElement } from "../helpers/global-helpers";


const useAccessSettingTour = ({
  setShowDummyCodeInput
}) => {
  const dispatch = useDispatch();

  const [driverObj, setDriverObj] = useState(null);
 function handleReset() {
      dispatch(setStartRoomTour(false));
      setShowDummyCodeInput(false)
    }

  const startRoomAccessTour = useCallback(() => {
    

    const tour = driver({
      showProgress: true,
      allowClose: false,
      showButtons: ["next"],
      overlayColor: "rgba(0, 0, 0, 0.5)",
      popoverOffset: 25,
      onDestroyed: () => {
        // dispatch(setStartRoomTour(false));
        // setShowDummyCodeInput(false)
        handleReset()
      },
      onReset: () => { handleReset() 
        // dispatch(setStartRoomTour(false)) 
      },
      onHighlighted: () => { dispatch(setStartRoomTour(true)) },
      steps: [
        {
          element: '[data-driver="room-access-tour-step-1"]',
          popover: {
            title: "Public rooms for anyone to join",
            description: `
            <div>
              <div style="margin-bottom: 1em;">Any one with the link would be eligible to join the Room</div>
              <div>Great if you are aiming to maximise exposure and reach as many people as possible</div>
              </div>
              `
          },


        },

        {
          element: '[data-driver="room-access-tour-step-2"]',
          popover: {
            title: "Private Rooms",
            description: `
                <div>
              <div style="margin-bottom: 1em;">New members strictly need to be invited by a current Room member.</div>
            <div>This works best if you want to use it for private conversations with your audiences</div>
              </div>`,
               onNextClick: async () => {
                            if (setShowDummyCodeInput) {
                              setShowDummyCodeInput(true);
                              await waitForElement('[data-driver="room-access-tour-step-3"]');
                              tour.moveNext();
                            } 
                          }
          },
        },
        {
          element: '[data-driver="room-access-tour-step-3"]',
          popover: {
            title: "Additional security",
            description: `
                <div>
              <div style="margin-bottom: 1em;">No matter whether your Room is an open or a private one, you may want to consider letting only members that received a passcode from you to enter. </div>
            <div>Works best if you require a level of privacy, or have very specific people in mind to engage with.</div>
              </div>
            `
          },
        }
      ],
    });

    setDriverObj(tour);
    tour.drive();

  }, [dispatch, setShowDummyCodeInput]);

  const stopRoomAccessTour = useCallback(() => {
    if (driverObj) {
      driverObj.stop();
    }
  }, [driverObj]);

  return { startRoomAccessTour, stopRoomAccessTour };
};

export default useAccessSettingTour